import { InfoIIcon } from '@moia-dev/pace-icons'
import { Icon, Text } from '@moia-dev/pace-web'
import { useTranslation } from 'react-i18next'

/** Read-only marker shown wherever a saved route is displayed rather than edited. */
export const AllWaypointsModeIndicator = () => {
  const { t } = useTranslation()

  return (
    <div
      css={theme => ({
        display: 'flex',
        alignItems: 'center',
        gap: theme.space.Space1,
        color: theme.semantic.ColorAccentDefault,
      })}
    >
      <Icon size={16}>
        <InfoIIcon />
      </Icon>
      <Text
        size="sm"
        css={theme => ({ color: theme.semantic.ColorAccentDefault })}
      >
        {t('routeBuilder_allWaypointsMode_indicator')}
      </Text>
    </div>
  )
}
